export default "__VITE_ASSET__DgSAVAF4__"